import { Routes, Route } from "react-router-dom";

import AppScreen from "./components/logic/AppScreen";
import ActivateAccount from "./components/logic/ActivateAccount";
import ForgotCredentialsPage from "./components/logic/ForgotCredentailsPage";
import RecoverAccount from "./components/logic/RecoverAccount";
import ProfilePage from "./components/ui/ProfilePage";
import AlarmGroupPage from "./components/ui/AlarmGroupPage";
import InviteUsers from "./components/logic/InviteUsers";
import DashboardPage from "./components/ui/DashboardPage";
import IndexPage from "./components/logic/IndexPage";
import InvitePage from "./components/logic/InvitePage";
import InvitationSummaryPage from "./components/ui/InvitationSummaryPage";

export default function App() {
	return (
		<Routes>
			<Route path="activate-account" element={<ActivateAccount />} />
			<Route path="recover-account" element={<RecoverAccount />} />
			<Route path="forgot" element={<ForgotCredentialsPage />} />

			<Route index element={<AppScreen><IndexPage /></AppScreen>} />
			<Route path="dashboard" element={<AppScreen><DashboardPage /></AppScreen>} />
			<Route path="alarm-group" element={<AppScreen><AlarmGroupPage /></AppScreen>} />
			<Route path="invite-users" element={<AppScreen><InviteUsers /></AppScreen>} />
			<Route path="profile" element={<AppScreen><ProfilePage /></AppScreen>} />
			<Route path="invites/:inviteID" element={<AppScreen><InvitePage /></AppScreen>} />
			<Route path="invitationsummary" element={<AppScreen><InvitationSummaryPage /></AppScreen>} />
			
			<Route path="*" element={<p>404</p>}/>
		</Routes>
	);
}

